<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="tachograph-out-oflnventory"
                    pagination="server"
                    search>
                        <template #filters>
                            <tachograph-out-of-inventory-plate-data-filter v-on:filter="filter($event)"></tachograph-out-of-inventory-plate-data-filter>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import TachographOutOfInventoryPlateDataFilter from './components/TachographOutOfInventoryPlateDataFilter.vue'

export default {
    components:{
        BCard,
        TachographOutOfInventoryPlateDataFilter
    },
    data(){
        return{
            loading:false,
            fields:[
                { name:"Sürücü Bilgisi",key:"DriverFullName", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                { name:"Dijital Ehliyet No",key:"DriverCardNumber", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                { name:"Plaka",key:"Plate",component:true,componentOptions:{name:"out-of-inventory-plate-info/OutOfInventoryPlateInfo"}, thClass:"w-10",tdClass:'text-nowrap',sortable:true,sortKey:'VehiclePlate'},
                { name:"Başlangıç Tarihi",key:"FirstUseDateStr", thClass:"w-15",tdClass:'text-nowrap',sortable:true,sortKey:'FirstUse'},
                { name:"Bitiş Tarihi",key:"LastUseDateStr", thClass:"w-15",tdClass:'text-nowrap',sortable:true,sortKey:'LastUse'},
                { name:"Zaman Farkı",key:"TimeDifference", thClass:"w-15",tdClass:'text-nowrap',sortable:false},
                { name:"Durum",key:"WrongPlateReason", thClass:"w-5",tdClass:'text-nowrap',sortable:true, component:true,componentOptions:{name:"out-of-inventory-plate-status/OutOfInventoryPlateStatus"}},
            ],
            filterData:{
                StartDate:null,
                EndDate:null,
                WrongPlateReason:null,
                HasVehiclePlateInfo:null
            }
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            return EmployeeOperationsApi.Tachograph.OutOfInventoryPlate({
                PaginationRequestModel:data,
                StartDate:this.filterData.StartDate,
                EndDate:this.filterData.EndDate,
                WrongPlateReason:this.filterData.WrongPlateReason,
                HasVehiclePlateInfo:this.filterData.HasVehiclePlateInfo
            })
        }
    }
}
</script>

<style>

</style>